import React from "react";

const RejectApplication = ({ updateInputChange, validation,value="" }) => {
  return (
    <div className="form-row">
      <div className={`form-group position-relative error-l-75 col-md-12 ${
        String(validation?.msg ?? "").length ? "hasValidationError" : ""
        }`}>
        <label htmlFor="mobileNumber">
          Reject Note<i>*</i>
        </label>
        <textarea
          type="text"
          className="form-control"
          name="mobileNumber"
          id="mobileNumber"
          value={value??""}
          placeholder="Reject Note"
          onChange={(e) => updateInputChange(e.target.value)}
        />
        <p className="error-message">
          {validation && validation.msg ? validation.msg : ""}
        </p>
      </div>
    </div>
  );
};

export default RejectApplication;
